import { createContext, useContext } from 'react';

/** Lets filter toolbars mount fixed overlays outside the sticky toolbar (marketplace-style). */
export const BrowseOverlayContext = createContext(null);

export function useBrowseOverlay() {
    return useContext(BrowseOverlayContext);
}
